<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';

import { useI18n } from 'vue-i18n';
import { useInlineNotifications } from '@thehotelsnetwork/lampo';

const emit = defineEmits(['update:modelValue']);

const props = withDefaults(defineProps<{
  properties: Array<any>;
  isCreation: Boolean;
  modelValue: Array<any>;
}>(), {
  properties: () => ([]),
  modelValue: () => ([]),
});

const { t } = useI18n();
const inlineNotifications = ref(null);
const {
  showInfo,
} = useInlineNotifications(inlineNotifications);

const value = ref(props.modelValue);

const options = ref(props.properties.map((item) => ({
  ...item,
  id: item.propertyId,
  brand: {},
  cluster: {},
})));

onMounted(async () => {
  if (props.isCreation) {
    showInfo({
      text: t('Skipping this step will leave the compset unassigned. You can always edit this later'),
      hideIcon: true,
    });
  }
});

watch(value, () => {
  emit('update:modelValue', value.value);
});

</script>

<template>
  <div class="flex flex-col gap-6">
    <p class="section-title">
      <slot name="title" />
    </p>
    <p class="font-normal text-base-900 text-xl">
      <slot name="description" />
    </p>
    <LpPropertySelect
      v-model="value"
      :properties="options"
      :search-placeholder="t('Search {count} properties', { count: properties.length })"
      class="max-h-[20rem] w-full h-80 p-3 border-base-400 border-1 rounded-xl"
    >
      <template #emptyProperties>
        <p class="m-3">
          {{ t('No results found') }}
        </p>
      </template>
    </LpPropertySelect>
  </div>
  <LpInlineNotifications
    ref="inlineNotifications"
    class="my-4"
  />
</template>
